<template>
  <v-card :class="item.done ? 'subtle' : ''">
    <v-card-title class="mb-0 pb-0">
      <v-layout row align-start justify-space-between>
        <v-flex shrink>
          <v-btn
            v-if="item.done"
            flat
            icon
            color="success"
            @click="markUndone"
          >
            <v-icon large>check_circle</v-icon>
          </v-btn>
          <v-btn
            v-else
            flat
            icon
            @click="markDone"
          >
            <v-icon large>radio_button_unchecked</v-icon>
          </v-btn>
        </v-flex>

        <v-flex>
          <v-layout row justify-space-between>
            <v-flex grow>
              <span class="title">
                <span :class="item.done ? 'todo-done' : ''">{{ item.task }}</span>
              </span>
            </v-flex>
            <v-flex shrink class="text-xs-right">
              <div v-if="item.priority" class="text-xs-right">
                <div v-if="item.created_by_id == user.id">
                  <v-btn flat icon color="red" class="ma-0" @click="openRemindPrompt">
                    <v-tooltip left>
                      <v-icon slot="activator">
                        feedback
                      </v-icon>
                      <span>Priority task (click to send reminder)</span>
                    </v-tooltip>
                  </v-btn>
                </div>
                <div v-else>
                  <v-tooltip left>
                    <v-icon slot="activator" color="red">
                      priority_high
                    </v-icon>
                    <span>The assigner has marked this task as high-priority</span>
                  </v-tooltip>
                </div>
              </div>

              <div>
                <div v-if="item.due_on" style="display: inline-block">
                  <span :class="overdue ? 'red--text' : ''">Due {{ $moment(item.due_on).fromNow() }}</span> <span class="subtle">({{ item.due_on | moment('MM/DD/YYYY') }})</span>
                </div>

                <div v-if="managed">
                  <v-tooltip left>
                    <v-chip slot="activator" icon v-if="item.task_type == 'ongoing'">
                      <v-icon>
                        repeat
                      </v-icon>
                    </v-chip>
                    <span>Automated task: Ongoing</span>
                  </v-tooltip>
                  <v-tooltip left>
                    <v-chip slot="activator" icon v-if="item.task_type == 'expire'">
                      <v-icon>
                        update
                      </v-icon>
                    </v-chip>
                    <span>Automated task: Expiration</span>
                  </v-tooltip>
                </div>
              </div>

            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-title>

    <v-card-text v-if="item.details" class="py-0">
      {{ item.details }}
    </v-card-text>

    <v-card-actions>
      <v-layout row>
        <v-flex v-if="managed">
          <router-link :to="{ name: 'managedTodoLists', query: { userID: user.id } }">
            <v-tooltip right>
              <v-chip slot="activator" style="cursor: pointer;" small @click="filterByEmployeeID(item.assigned_user.id)">
                {{ item.assigned_user.first_name }} {{ item.assigned_user.last_name }}
              </v-chip>
              <span>View users's tasks</span>
            </v-tooltip>
          </router-link>
        </v-flex>

        <v-flex v-if="!managed && item.created_by_id !== user.id">
          <v-chip color="error" text-color="white" class="font-weight-bold">Assigned to me</v-chip>
        </v-flex>

        <v-flex v-if="item.done" class="text-xs-right"> <span>Completed on {{ item.done_on | moment('MM/DD/YYYY') }} at {{ item.done_on | moment('h:mma') }} </span> by <span class="mr-1">{{ completedBy }}</span>
        </v-flex>

      </v-layout>
    </v-card-actions>

    <v-dialog
      v-model="reminderPrompt"
      max-width="500"
    >
      <v-card>
        <v-card-title><h2 class="headline">Send Reminder?</h2></v-card-title>
        <v-card-text>
          This will send the following internal message to the assignee:
          <blockquote class="ma-4 font-italic">
            Reminder: complete the "{{ item.task }}" task.
          </blockquote>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" flat @click="cancelReminder">Nevermind</v-btn>
          <v-btn color="success" @click="sendReminder">Send!</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: [
    'item',
    'managed',
  ],
  data() {
    return {
      expanded: false,
      reminderPrompt: false,
    }
  },
  computed: {
    ...mapState('userAuth', ['user']),
    overdue() {
      const now = this.$moment()
      return (!this.item.done && this.item.due_on && this.$moment(this.item.due_on).isBefore(now))
    },
    completedBy() {
      if (this.item.done_by_id === this.user.id) {
        return 'You'
      } else {
        return 'Another user'
      }
    },
  },
  methods: {
    markDone() {
      this.$store.dispatch('todos/markDone', this.item.id)
      .then((r) => {
      })
    },
    markUndone() {
      this.$store.dispatch('todos/markUndone', this.item.id)
      .then((r) => {
      })
    },
    filterByEmployeeID(id) {
      console.log('hi')
      this.$router.push({
        name: 'managedTodoLists',
        query: { userID: id }
      })
    },

    openRemindPrompt() {
      this.reminderPrompt = true
    },
    sendReminder() {
      this.$store.dispatch('todos/sendReminder', this.item.id)
      .then((r) => {
        this.$store.dispatch(
          'global/showSnackbarSuccess',
          {message: "Reminder sent!"},
          {root: true},
        );
        this.reminderPrompt = false
      }).error((e) => {
        this.$store.dispatch(
          'global/showSnackbarError',
          {message: "Something went wrong sending that reminder..."},
          {root: true},
        );
        this.reminderPrompt = false
      }).finally((r) => {
        this.reminderPrompt = false
      })
    },
    cancelReminder() {
      this.reminderPrompt = false
    },
  },
}
</script>

<style>
.todo-done {
  text-decoration: line-through;
}
</style>
